import React, { useEffect, useState, useContext } from 'react';
import Axios from 'axios';
import { API_HOST } from '../../consts';
import { withRouter } from 'react-router-dom';
import TableGeneralStudentReport from '../relatorio/TableGeneralStudentReport';
import { Nav, NavItem, NavLink } from 'reactstrap';
import classnames from 'classnames';
import SerialLineChart from '../relatorio/SerialLineChart';
import { withStyles } from '@material-ui/core/styles';
import MuiAccordion from '@material-ui/core/Accordion';
import MuiAccordionSummary from '@material-ui/core/AccordionSummary';
import MuiAccordionDetails from '@material-ui/core/AccordionDetails';
import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown';
import HelpOutlinedIcon from '@material-ui/icons/HelpOutlined';
import { Grid } from '@material-ui/core';
import { ThemeContext } from '../../contexts/ThemeContext';
import { FilterRelatorioContext } from '../../contexts/FilterRelatorioProvider/Context';
import InsufficientData from '../../components/InsufficientData';

const GeneralStudentReport = ({ match }) => {
  const { filtrosRelatorios, setStateFilters } = useContext(
    FilterRelatorioContext
  );
  const [habilidadeData, setHabilidadeData] = useState([]);
  const [competenciaData, setCompetenciaData] = useState([]);
  const [boletimData, setBoletimData] = useState(undefined);
  const [dadosDisciplinas, setDadosDisciplinas] = useState([]);
  const [periodo, setPeriodo] = useState(filtrosRelatorios.periodoAno);
  const [activeTab, setActiveTab] = useState(filtrosRelatorios.periodoAno);
  const [escala, setEscala] = useState({});
  const [dadosAreaConhecimento, setDadosAreaConhecimento] = useState([]);
  const [isTourOpen, setIsTourOpen] = useState(false);
  const idn = filtrosRelatorios.currentStudent;

  const theme = useContext(ThemeContext);

  const Accordion = withStyles({
    root: {
      boxShadow: 'none',
      '&:not(:last-child)': {
        borderBottom: 0
      },
      '&:before': {
        display: 'none'
      },
      '&$expanded': {
        marginTop: '10px',
        marginBottom: '10px',
        margin: 'auto'
      }
    },
    expanded: {}
  })(MuiAccordion);

  const AccordionSummary = withStyles({
    root: {
      display: 'flex',
      alignItems: 'center',
      backgroundColor: theme.primary,
      border: 'none',
      borderRadius: '16px',
      height: '42px',
      boxShadow: '0px 0px 4.94866px rgba(0, 0, 0, 0.25)',
      marginBottom: '10px',
      '&$expanded': {
        minHeight: 56
      }
    },
    content: {
      '&$expanded': {
        margin: '12px 0'
      }
    },
    expanded: {}
  })(MuiAccordionSummary);

  const AccordionDetails = withStyles((theme) => ({
    root: {
      width: '100%',
      backgroundColor: '#FFFFFF',
      padding: theme.spacing(2),
      border: '1px solid #F7F7F7',
      borderRadius: '8px'
    }
  }))(MuiAccordionDetails);

  const fetchHabilidade = () => {
    Axios.get(
      `${API_HOST}/avalia/estudante_desempenho/${idn}/get_complex_data_table?tipo=${'aluno-habilidade'}&periodo_id=${periodo}`
    )
      .then((res) => {
        setHabilidadeData(res.data);
      })
      .catch((err) => console.error(err));
  };

  const fetchCompetencia = () => {
    Axios.get(
      `${API_HOST}/avalia/estudante_desempenho/${idn}/get_complex_data_table?tipo=${'aluno-competencia'}`
    )
      .then((res) => {
        setCompetenciaData(res.data.data);
      })
      .catch((err) => console.error(err));
  };

  const fetchDataDisciplinas = () => {
    const params = {
      idn: idn,
      tipo: 'estudante-disciplina'
    };
    Axios.get(`${API_HOST}/avalia/estudante/get_notas_to_line_chart`, {
      params
    }).then((response) => {
      setDadosDisciplinas(response.data.data.data);
    });
  };

  const fetchDataAreaConhecimento = (value = null) => {
    const params = {
      idn: idn,
      tipo: 'estudante-area-conhecimento',
      periodo: value ? value : periodo
    };
    Axios.get(`${API_HOST}/avalia/estudante/get_notas_to_line_chart`, {
      params
    })
      .then((response) => {
        setDadosAreaConhecimento(response.data.data.data);

        setEscala({ area_conhecimento: response.data.data.escala });
      })
      .catch((err) => {
        setDadosAreaConhecimento([]);
      });
  };

  const columnsHabilidade = [
    { id: 'habilidade', label: 'Habilidade', minWidth: 170, align: 'center' },
    {
      id: 'area_conhecimento',
      label: 'Area Conhecimento',
      minWidth: 170,
      align: 'center'
    },
    {
      id: 'qtd_total',
      label: 'Quantidade Testada',
      minWidth: 170,
      align: 'center'
    },
    { id: 'qtd', label: 'Acertos', minWidth: 170, align: 'center' },
    {
      id: 'porc_acertos',
      label: 'Porc. Acertos',
      minWidth: 170,
      align: 'center'
    },
    { id: 'status', label: 'Status', minWidth: 170, align: 'center' }
  ];

  const columnsCompetencia = [
    { id: 'competencia', label: 'Competência', minWidth: 170, align: 'center' },
    {
      id: 'area_conhecimento',
      label: 'Area Conhecimento',
      minWidth: 170,
      align: 'center'
    },
    {
      id: 'qtd_total',
      label: 'Quantidade Testada',
      minWidth: 170,
      align: 'center'
    },
    { id: 'qtd', label: 'Acertos', minWidth: 170, align: 'center' },
    {
      id: 'porc_acertos',
      label: 'Porc. Acertos',
      minWidth: 170,
      align: 'center'
    },
    { id: 'status', label: 'Status', minWidth: 170, align: 'center' }
  ];

  const fetchBoletimData = () => {
    Axios.get(
      `${API_HOST}/avalia/boletim_mt/${idn}?PERIODO_ANO_ID__id=${periodo}`
    )
      .then((res) => {
        setBoletimData(res.data);
      })
      .catch((err) => {
        console.error(err);
      });
  };

  useEffect(() => {
    fetchHabilidade();
    fetchCompetencia();
    fetchBoletimData();
    fetchDataDisciplinas();
    fetchDataAreaConhecimento();
  }, []);

  const closeTour = () => {
    setIsTourOpen(false);
  };

  const host = window.location.host;

  return (
    <>
      <div
        className="card-header"
        style={{
          width: '100%',
          marginBottom: '-0.7rem',
          backgroundColor: '#f7f7f7',
          borderRadius: '10px'
        }}
      >
        <span
          style={{
            fontSize: '14px',
            color: '#292929',
            fontWeight: 500,
            fontFamily: 'Quicksand'
          }}
        >
          Visão Geral do Aluno
        </span>
        <hr
          style={{
            background: '#bebebe',
            width: '100%',
            height: '1px',
            borderRadius: '1px'
          }}
        />
      </div>
      <div
        className="input-type-style"
        style={{
          display: 'flex',
          justifyContent: 'center',
          marginLeft: '4rem',
          flexDirection: 'column'
        }}
      >
        <Accordion
          defaultExpanded
          style={{ marginTop: '1rem', width: '100%' }}
        >
          <AccordionSummary
            expandIcon={
              <ArrowDropDownIcon
                style={{ fontSize: '2.5rem', color: '#FFFFFF' }}
              />
            }
            aria-controls="panel1d-content"
            id="panel1d-header"
          >
            <div
              style={{
                width: '100%',
                display: 'flex',
                alignItems: 'center'
              }}
            >
              <label
                style={{
                  color: '#FFFFFF',
                  fontFamily: 'Quicksand',
                  fontWeight: '700',
                  fontSize: '19px',
                  marginBottom: '2px',
                  marginRight: '5px'
                }}
              >
                Relatórios por disciplinas
              </label>
              <HelpOutlinedIcon
                style={{ fontSize: '19px', color: theme.secondary }}
              />
            </div>
          </AccordionSummary>
          <AccordionDetails>
            <Grid item container xs={12} md={12}>
              {/* <Grid item xs={12}>
                          {dadosDisciplinas &&
                            dadosDisciplinas.map((element) =>
                              element['titulo'] ? (
                                <SerialLineChart
                                  style={{ width: '100%' }}
                                  titulo={element['titulo']}
                                  dados={element['inform']}
                                  tituloCompleto={`Gráfico de desempenho em ${element['titulo']}`}
                                />
                              ) : (
                                <></>
                              )
                            )}
                        </Grid> */}
            </Grid>
          </AccordionDetails>
        </Accordion>

        <Accordion defaultExpanded style={{ marginTop: '1rem', width: '100%' }}>
          <AccordionSummary
            expandIcon={
              <ArrowDropDownIcon
                style={{ fontSize: '2.5rem', color: '#FFFFFF' }}
              />
            }
            aria-controls="panel1d-content"
            id="panel1d-header"
          >
            <div
              style={{
                width: '100%',
                display: 'flex',
                alignItems: 'center'
              }}
            >
              <label
                style={{
                  color: '#FFFFFF',
                  fontFamily: 'Quicksand',
                  fontWeight: '700',
                  fontSize: '19px',
                  marginBottom: '2px',
                  marginRight: '5px'
                }}
              >
                Relatórios por área de conhecimento
              </label>
              <HelpOutlinedIcon
                style={{ fontSize: '19px', color: theme.secondary }}
              />
            </div>
          </AccordionSummary>
          <AccordionDetails>
            <Grid item container xs={12} sm={12} md={12}>
              {window.location.host.includes('sesi') && (
                <Nav tabs>
                  <NavItem>
                    <NavLink
                      className={classnames({
                        active: activeTab === '1'
                      })}
                      onClick={() => {
                        setPeriodo(1);
                        fetchDataAreaConhecimento(1);
                        fetchHabilidade(1);
                        setActiveTab('diagnostica');
                      }}
                    >
                      Avaliação Diagnóstica 2023
                    </NavLink>
                  </NavItem>
                  <NavItem>
                    <NavLink
                      className={classnames({
                        active: activeTab === '2'
                      })}
                      onClick={() => {
                        setPeriodo(2);
                        fetchDataAreaConhecimento(2);
                        fetchHabilidade(2);
                        setActiveTab('sesi_1_semestre');
                      }}
                    >
                      Avalia SESI 1º Semestre
                    </NavLink>
                  </NavItem>
                  <NavItem>
                    <NavLink
                      className={classnames({
                        active: activeTab === '5'
                      })}
                      onClick={() => {
                        setPeriodo(5);
                        fetchDataAreaConhecimento(5);
                        fetchHabilidade(5);
                        setActiveTab('sesi_2_semestre');
                      }}
                    >
                      Avalia SESI 2º Semestre
                    </NavLink>
                  </NavItem>
                  <NavItem>
                    <NavLink
                      className={classnames({
                        active: activeTab === '4'
                      })}
                      onClick={() => {
                        setPeriodo(4);
                        fetchDataAreaConhecimento(4);
                        fetchHabilidade(4);
                        setActiveTab('avaliacao_enem_saeb');
                      }}
                    >
                      Avaliação modelo ENEM/SAEB
                    </NavLink>
                  </NavItem>
                </Nav>
              )}
              <Grid item xs={12}>
                {dadosAreaConhecimento && dadosAreaConhecimento.length > 0 ? (
                  dadosAreaConhecimento.map((element) =>
                    element['titulo'] ? (
                      <SerialLineChart
                        escala={escala['area_conhecimento']}
                        titulo={element['titulo']}
                        dados={element['inform']}
                        tituloCompleto={`Gráfico de desempenho em ${element['titulo']}`}
                      />
                    ) : (
                      <InsufficientData />
                    )
                  )
                ) : (
                  <InsufficientData />
                )}
              </Grid>
            </Grid>
          </AccordionDetails>
        </Accordion>

        <Accordion defaultExpanded style={{ marginTop: '1rem', width: '100%' }}>
          <AccordionSummary
            expandIcon={
              <ArrowDropDownIcon
                style={{ fontSize: '2.5rem', color: '#FFFFFF' }}
              />
            }
            aria-controls="panel1d-content"
            id="panel1d-header"
          >
            <div
              style={{
                width: '100%',
                display: 'flex',
                alignItems: 'center'
              }}
            >
              <label
                style={{
                  color: '#FFFFFF',
                  fontFamily: 'Quicksand',
                  fontWeight: '700',
                  fontSize: '19px',
                  marginBottom: '2px',
                  marginRight: '5px'
                }}
              >
                Relatórios por Habilidades e Competências
              </label>
              <HelpOutlinedIcon
                style={{ fontSize: '19px', color: theme.secondary }}
              />
            </div>
          </AccordionSummary>
          <AccordionDetails>
            <Grid item container xs={12} sm={12} md={12}>
              <Grid item xs={12}>
                <TableGeneralStudentReport
                  title="Habilidade"
                  columns={columnsHabilidade}
                  rows={habilidadeData}
                  pagination={true}
                  tourSelector="tabela-habilidade"
                />
                <TableGeneralStudentReport
                  title="Competência"
                  columns={columnsCompetencia}
                  rows={competenciaData}
                  pagination={true}
                  tourSelector="tabela-competencia"
                />
              </Grid>
            </Grid>
          </AccordionDetails>
        </Accordion>
      </div>
    </>
  );
};

export default withRouter(GeneralStudentReport);
